import React from "react";
import DOMPurify from "dompurify";

export default function RenderHTML({ code }) {
  const cleanHTMLCode = DOMPurify.sanitize(code, {
    ADD_TAGS: ["iframe"]
  });
  return <div dangerouslySetInnerHTML={{ __html: cleanHTMLCode }} />;
}
